import classNames from "classnames";
import { useMemo } from "react";
import styles from "./styles.module.scss";
import { ReactComponent as OpenBoxDone } from "../../../assets/images/svg/open_box-done.svg";
import { ReactComponent as OpenBox } from "../../../assets/images/svg/open_box.svg";
import { ReactComponent as Return } from "../../../assets/images/svg/return.svg";
import { ReactComponent as PackageBox } from "../../../assets/images/svg/package_box.svg";

const colors = {
  SUCCESS_CONTRACT: "doneBg",
  ACTIVE_CONTRACT: "primaryBg",
  ESCALATION: "pending",
  ESCALATION_DONE: "delivery",
};

type Props = {
  title: string;
  item: {
    key: string;
    items: string[];
    icon: any;
  };
  values: { [key: string]: { count: number; totalAmount: number } };
  MAP_STATE_TEXT: { [key: string]: string };
};

const icons = {
  OpenBoxDone: <OpenBoxDone />,
  OpenBox: <OpenBox />,
  Return: <Return />,
  PackageBox: <PackageBox />,
};

const ContractStats = ({
  item,
  title,
  values = {},
  MAP_STATE_TEXT,
}: Props): JSX.Element => {
  const total = useMemo(() => {
    return item?.items?.reduce(
      (acc, item) => acc + (values[item]?.count || 0),
      0
    );
  }, [item, values]);

  return (
    <div
      className={classNames(styles.statsContainer, styles.column)}
      style={{ width: "100%" }}>
      <div
        className={classNames(
          styles[colors[item?.key]],
          styles.row,
          styles.statsCard
        )}>
        {icons[item?.icon]}
        <div className={styles.column}>
          <p className={classNames(styles.p3, styles.colorWhite)}>{title}</p>
          <p className={classNames(styles.p3, styles.colorWhite)}>{total}</p>
        </div>
      </div>
      {item?.items?.map((itemVar) => (
        <div
          className={classNames(
            styles.line,
            styles[`${colors[item?.key]}_opacity`]
          )}
          key={itemVar}>
          <p className={styles.count}>{values[itemVar]?.count || 0}</p>
          <p className={styles.p2}>{MAP_STATE_TEXT[itemVar]}</p>
        </div>
      ))}
    </div>
  );
};

export default ContractStats;
